<template>
  <div>
    <team
      v-for="team in teams"
      :team="team"
      :key="team.id"
    />

    <button
      class="add-content-button"
      @click.prevent="openFolderModal"
    />
    <folder-modal />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import Team from '@/components/teams/TeamWithFolders'
import FolderModal from '@/components/folders/FolderModal'

export default {
  name: 'FoldersPage',
  components: {
    Team,
    FolderModal
  },
  computed: {
    ...mapState({
      teams: state => state.teams.teams
    })
  },
  methods: {
    ...mapActions([
      'fetchTeams',
      'openFolderModal'
    ])
  },
  created () {
    this.fetchTeams()
      .then(() => {
        this.$emit('loadingDone')
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/folders/FoldersPage.vue